import script from "./LogoutSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutSvg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__